import React, { useEffect, useRef } from "react";
import "./OurServices1.css";
import service from "../images/services.jpg";

const OurServices1 = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    const elements = containerRef.current?.querySelectorAll(".animate-side");
    elements?.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section className="our-services1-1" ref={containerRef}>
      <div className="our-services1-2">
        <div className="imgservices animate-side slide-right">
          <img className="serviceimg" src={service} alt="Web development services" />
        </div>
      </div>
    </section>
  );
};

export default OurServices1;